import { render, staticRenderFns } from "./RulesDetail.vue?vue&type=template&id=d17cff7e&scoped=true"
import script from "./RulesDetail.vue?vue&type=script&lang=ts"
export * from "./RulesDetail.vue?vue&type=script&lang=ts"
import style0 from "./RulesDetail.vue?vue&type=style&index=0&id=d17cff7e&lang=scss"
import style1 from "./RulesDetail.vue?vue&type=style&index=1&id=d17cff7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17cff7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d17cff7e')) {
      api.createRecord('d17cff7e', component.options)
    } else {
      api.reload('d17cff7e', component.options)
    }
    module.hot.accept("./RulesDetail.vue?vue&type=template&id=d17cff7e&scoped=true", function () {
      api.rerender('d17cff7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rules/components/RulesDetail.vue"
export default component.exports